export const environment = {
  production: true,
  defaultLanguage: 'es',
  selectedLanguage: 'es',
  supportedLanguages: ['en', 'es'],
  //baseUrl: 'https://testintercessorylivingwd.azurewebsites.net/api/', //
  // baseUrl: 'https://intercessory.livingwd.org/api/', // ENGLISH VERSION
  baseUrl: 'https://intercessory-sp.livingwd.org/api/', // SPANISH VERSION
  //baseUrl: 'https://bwmicp-5id63zeigytdf.billwinston.org/api/', //
  courseId: 1,
  courseStructure: {
    totalClasses: 10,
    activitiesPerClass: 3, // video, handout, quiz
    get totalActivities() { return this.totalClasses * this.activitiesPerClass; }
  },
  translationConfig: {
    fallbackLanguage: 'es',
    enableBrowserLanguageDetection: true,
    enableLocalStorage: true,
    translationPath: './assets/i18n/',
    translationSuffix: '.json'
  },
  courseSettings: {
    // Production: 7 days waiting period between classes
    classCooldownPeriod: {
      days: 7,
      hours: 0, // 7 days * 24 hours
      minutes: 0 // 7 days * 24 hours * 60 minutes
    },
  },
  classManual: 'https://online.fliphtml5.com/qubm/vqdf/',
  classFAQ: 'https://online.fliphtml5.com/qubm/bklt/#p=1',
  classDocuments: {
    Class1: {
      documentUrl: 'https://online.fliphtml5.com/qubm/fbkw/'
    },
    Class2: {
      documentUrl: 'https://online.fliphtml5.com/qubm/jzgh/'
    },
    Class3: {
      documentUrl: 'https://online.fliphtml5.com/qubm/wogs/'
    },
    Class4: {
      documentUrl: 'https://online.fliphtml5.com/qubm/lmht/'
    },
    Class5: {
      documentUrl: 'https://online.fliphtml5.com/qubm/sqfe/'
    },
    Class6: {
      documentUrl: 'https://online.fliphtml5.com/qubm/jkjg/'
    },
    Class7: {
      documentUrl: 'https://online.fliphtml5.com/qubm/xriv/'
    },
    Class8: {
      documentUrl: 'https://online.fliphtml5.com/qubm/rlts/'
    },
    Class9: {
      documentUrl: 'https://online.fliphtml5.com/qubm/bbrs/'
    },
    Class10: {
      documentUrl: 'https://online.fliphtml5.com/qubm/kizr/'
    }
  }
};
